<div class="flex flex-column gap-3">
  <div class="text-lg-semibold text-gray-900">Termini klijenta</div>
  <app-client-appointments-table [userId]="clientId()"></app-client-appointments-table>
</div>
